import { h, FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { OpenInNewTabIcon } from '~src/domains/common/assets/svg';
import LinkWrapper from '~src/domains/common/components/LinkWrapper';
import { Brand } from '~src/domains/common/enums/common';
import { Doc } from '~src/domains/common/enums/docs';
import { Language } from '~src/domains/common/enums/localization';
import {
  brandSelector,
  commonDocsSelector,
} from '~src/domains/common/state/commonSelectors';
import * as styles from '~src/styles/domains/loanConsent/LoanConsentPage.module.scss';

type OpenInNewTabLinkProps = {
  name: string;
  docId: Doc;
};

/**
 * Link component that opens a new tab to the document
 *
 * @param name: name displayed
 * @param docId: id that links to document
 *
 */
const OpenInNewTabLink: FunctionComponent<OpenInNewTabLinkProps> = ({
  name,
  docId,
}) => {
  const brand = useSelector(brandSelector);
  const commonDocs = useSelector(commonDocsSelector);
  const isUplift = brand == Brand.UPLIFT;

  const onClickHandler = () => {
    // Get the URL for the document from commonDocs
    const docUrl = commonDocs?.[docId]?.url;

    if (docUrl) {
      // Open the URL in a new tab
      window.open(docUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className={styles['agreement-item']}>
      <OpenInNewTabIcon
        size={20}
        color={
          isUplift
            ? styles.documentIconColorUplift
            : styles.documentIconColorUpgrade
        }
      />
      <LinkWrapper
        id={`open-in-new-tab-${docId}`}
        onClickHandler={onClickHandler}
        href={commonDocs?.[docId]?.url || ''}
        target='_blank'
      >
        {name}
      </LinkWrapper>
    </div>
  );
};

export default OpenInNewTabLink;
